import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { Navbar } from './Navbar';
import { CardSpotlight } from './CardSpotlight';

export const SiteShell = ({ children }) => {
  const reduce = useReducedMotion();

  // Very slow, very subtle ambient drift/breathe for the background glows.
  // Compositor-only (transform translate + opacity), long loops, low amplitude.
  // Fully disabled under reduced motion.
  const glowA = reduce
    ? {}
    : {
        animate: { x: [0, 18, 0], y: [0, -14, 0], opacity: [0.85, 1, 0.85] },
        transition: { duration: 16, ease: 'easeInOut', repeat: Infinity },
      };
  const glowB = reduce
    ? {}
    : {
        animate: { x: [0, -16, 0], y: [0, 12, 0], opacity: [0.9, 1, 0.9] },
        transition: { duration: 13, ease: 'easeInOut', repeat: Infinity, delay: 1.5 },
      };
  const glowC = reduce
    ? {}
    : {
        animate: { x: [0, 14, 0], y: [0, 16, 0], opacity: [0.8, 0.95, 0.8] },
        transition: { duration: 19, ease: 'easeInOut', repeat: Infinity, delay: 3 },
      };

  return (
    <div className="min-h-screen bg-white text-[#1C1C1E] selection:bg-orange-500/30">
      {/* Global Background — light, with faint warm glows */}
      <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden">
        {/* Warm off-white base */}
        <div className="absolute inset-0 bg-white" />

        {/* Subtle warm glows */}
        <motion.div
          className="absolute top-[-20%] left-[-10%] w-[50%] h-[50%] bg-[#FF6A00]/[0.05] blur-[120px] rounded-full"
          {...glowA}
        />
        <motion.div
          className="absolute top-[20%] right-[-10%] w-[40%] h-[40%] bg-[#FF6A00]/[0.04] blur-[120px] rounded-full"
          {...glowB}
        />
        <motion.div
          className="absolute bottom-[-10%] left-[20%] w-[60%] h-[40%] bg-[#FF6A00]/[0.03] blur-[100px] rounded-full"
          {...glowC}
        />

        {/* Noise overlay */}
        <div className="absolute inset-0 opacity-[0.02] mix-blend-multiply"
             style={{ backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")` }}
        />
      </div>

      <Navbar />
      <CardSpotlight />

      <main className="relative z-10 pt-0 pb-0">
        {children}
      </main>

      {/* Footer can be added here later or passed as children */}
    </div>
  );
};

export const SectionContainer = ({ children, className = "" }) => (
  <div className={`w-full max-w-[1120px] mx-auto px-6 ${className}`}>
    {children}
  </div>
);
